import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _83dfe29a = () => interopDefault(import('../pages/account.vue' /* webpackChunkName: "pages/account" */))
const _cbd4fa14 = () => interopDefault(import('../pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _1b9e3aba = () => interopDefault(import('../pages/account/alerts.vue' /* webpackChunkName: "pages/account/alerts" */))
const _5f2f0ffe = () => interopDefault(import('../pages/account/newsletters.vue' /* webpackChunkName: "pages/account/newsletters" */))
const _4fa70b73 = () => interopDefault(import('../pages/account/newsletters-archive.vue' /* webpackChunkName: "pages/account/newsletters-archive" */))
const _a658681e = () => interopDefault(import('../pages/account/orders.vue' /* webpackChunkName: "pages/account/orders" */))
const _44f11ab2 = () => interopDefault(import('../pages/account/research.vue' /* webpackChunkName: "pages/account/research" */))
const _1008844b = () => interopDefault(import('../pages/article-binder.vue' /* webpackChunkName: "pages/article-binder" */))
const _0649c83e = () => interopDefault(import('../pages/calendars/index.vue' /* webpackChunkName: "pages/calendars/index" */))
const _cada89c8 = () => interopDefault(import('../pages/debug/index.vue' /* webpackChunkName: "pages/debug/index" */))
const _429faff5 = () => interopDefault(import('../pages/dossiers/index.vue' /* webpackChunkName: "pages/dossiers/index" */))
const _5fad7bbe = () => interopDefault(import('../pages/in-short.vue' /* webpackChunkName: "pages/in-short" */))
const _245f20c3 = () => interopDefault(import('../pages/jobs/index.vue' /* webpackChunkName: "pages/jobs/index" */))
const _2e9f220c = () => interopDefault(import('../pages/payment.vue' /* webpackChunkName: "pages/payment" */))
const _3d268e12 = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _12698f08 = () => interopDefault(import('../pages/subscriptions.vue' /* webpackChunkName: "pages/subscriptions" */))
const _4f0794f8 = () => interopDefault(import('../pages/admin/image-search.vue' /* webpackChunkName: "pages/admin/image-search" */))
const _752c7086 = () => interopDefault(import('../pages/auth/google.vue' /* webpackChunkName: "pages/auth/google" */))
const _39c57f8b = () => interopDefault(import('../pages/auth/linkedin.vue' /* webpackChunkName: "pages/auth/linkedin" */))
const _40e90ead = () => interopDefault(import('../pages/dossiers/_slug.vue' /* webpackChunkName: "pages/dossiers/_slug" */))
const _22a87f7b = () => interopDefault(import('../pages/jobs/_slug.vue' /* webpackChunkName: "pages/jobs/_slug" */))
const _64a75274 = () => interopDefault(import('../pages/page/_slug.vue' /* webpackChunkName: "pages/page/_slug" */))
const _32c0dbaa = () => interopDefault(import('../pages/pagina/_slug.vue' /* webpackChunkName: "pages/pagina/_slug" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _2efaf336 = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _83dfe29a,
    meta: {"scrollToTop":true},
    children: [{
      path: "",
      component: _cbd4fa14,
      meta: {"scrollToTop":true,"fetchOnServer":false},
      name: "account"
    }, {
      path: "alerts",
      component: _1b9e3aba,
      meta: {"scrollToTop":true,"validations":{"alert":{"maxResults":{},"displayText":{},"languageId":{}}}},
      name: "account-alerts"
    }, {
      path: "newsletters",
      component: _5f2f0ffe,
      meta: {},
      name: "account-newsletters"
    }, {
      path: "newsletters-archive",
      component: _4fa70b73,
      meta: {},
      name: "account-newsletters-archive"
    }, {
      path: "orders",
      component: _a658681e,
      meta: {"scrollToTop":true},
      name: "account-orders"
    }, {
      path: "research",
      component: _44f11ab2,
      meta: {"scrollToTop":true},
      name: "account-research"
    }]
  }, {
    path: "/article-binder",
    component: _1008844b,
    meta: {"scrollToTop":true},
    name: "article-binder"
  }, {
    path: "/calendars",
    component: _0649c83e,
    meta: {"name":"Calendars","scrollToTop":true},
    name: "calendars"
  }, {
    path: "/debug",
    component: _cada89c8,
    meta: {"layout":"blank","scrollToTop":true,"auth":false},
    name: "debug"
  }, {
    path: "/dossiers",
    component: _429faff5,
    meta: {"name":"DossierList","scrollToTop":true,"fetchOnServer":false},
    name: "dossiers"
  }, {
    path: "/in-short",
    component: _5fad7bbe,
    meta: {"name":"InShortPage","layout":"generic","scrollToTop":true,"fetchOnServer":true},
    name: "in-short"
  }, {
    path: "/jobs",
    component: _245f20c3,
    meta: {"name":"JobList","scrollToTop":true,"fetchOnServer":false},
    name: "jobs"
  }, {
    path: "/payment",
    component: _2e9f220c,
    meta: {"name":"Payment","scrollToTop":true,"fetchOnServer":false,"fetchKey":"payments","validations":{"user":{"company":{},"firstName":{},"lastName":{},"address":{},"postcode":{},"city":{},"idCountry":{},"phoneNumber":{},"vat":{}},"invoice":{"poNumber":{}},"paymentInvoice":{"email":{},"name":{},"company":{},"address":{},"postcode":{},"city":{},"countryId":{}}}},
    name: "payment"
  }, {
    path: "/search",
    component: _3d268e12,
    meta: {"name":"SearchPage","fetchOnServer":false},
    name: "search"
  }, {
    path: "/subscriptions",
    component: _12698f08,
    meta: {"name":"Subscriptions","scrollToTop":true},
    name: "subscriptions"
  }, {
    path: "/admin/image-search",
    component: _4f0794f8,
    meta: {"name":"ImageSearchPage","scrollToTop":true,"fetchOnServer":false},
    name: "admin-image-search"
  }, {
    path: "/auth/google",
    component: _752c7086,
    meta: {"name":"GoogleAuthCallback","auth":"guest","layout":"default"},
    name: "auth-google"
  }, {
    path: "/auth/linkedin",
    component: _39c57f8b,
    meta: {"name":"LinkedInAuthCallback","auth":"guest","layout":"default"},
    name: "auth-linkedin"
  }, {
    path: "/dossiers/:slug",
    component: _40e90ead,
    meta: {"name":"Dossier","fetchOnServer":true,"scrollToTop":true},
    name: "dossiers-slug"
  }, {
    path: "/jobs/:slug",
    component: _22a87f7b,
    meta: {"name":"Job","fetchOnServer":false,"scrollToTop":true},
    name: "jobs-slug"
  }, {
    path: "/page/:slug?",
    component: _64a75274,
    meta: {},
    name: "page-slug"
  }, {
    path: "/pagina/:slug?",
    component: _32c0dbaa,
    meta: {},
    name: "pagina-slug"
  }, {
    path: "/",
    component: _2dfb1658,
    meta: {"name":"HomePage","fetchOnServer":true,"scrollToTop":true},
    name: "index"
  }, {
    path: "/*",
    component: _2efaf336,
    meta: {},
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
